// extracted by mini-css-extract-plugin
export var social_icons = "social-media-module--social_icons--9c8d2";